/**
 * Compares two strings, adjusting for numerals. For example, in the default
 * string sort "10" shows up before "2". This method ensures sorting is intuitive.
 * Returns -1 if the first string should come after the second, 1 if the first
 * string should come before the second or 0 if strings are equal.
 * @param a The first string to compare
 * @param b The second string to compare
 */
export const compareAlphanumeric = (a: string, b: string): number =>
  a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base',
  })

export const capitalizeText = (text: string) =>
  text
    .replace(/([A-Z])/g, ' $1') // This line inserts a space before each uppercase letter.
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

/**
 * Checks if `toCheck` is included in `base`, ignoring capitalization.
 */
export function includesIgnoreCase(base: string, toCheck: string): boolean {
  return base.toLowerCase().includes(toCheck.toLowerCase())
}

export const removeSpecialCharacters = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, '')
}
